// Get jQuery from global scope
const $ = window.jQuery;

$(document).ready(function () {
  // 1. Owl Carousel
  var $owlCarousel = $(".owl-carousel");
  if ($owlCarousel.length && !$owlCarousel.hasClass("slick-initialized")) {
    try {
      $owlCarousel.slick({
        slidesToShow: 1,
        vertical: false,
        arrows: true,
        dots: false,
        autoplay: true,
        adaptiveHeight: false,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none"><path d="M20 10.1117L18.225 11.8867L10 3.66172L1.775 11.8867L0 10.1117L10 0.111718L20 10.1117Z" fill="#151820"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none"><path d="M20 1.88828L18.225 0.113281L10 8.33828L1.775 0.113281L0 1.88828L10 11.8883L20 1.88828Z" fill="#151820"/></svg></button>',
      });
    } catch (error) {
      console.warn("Owl carousel slider initialization failed:", error);
    }
  }

  // 2. Related Case Studies slider for mobile
  function initRelatedCaseStudies() {
    var $relatedCaseStudies = $(".related-case-studies__cases--slider");
    if ($relatedCaseStudies.length && !$relatedCaseStudies.hasClass("slick-initialized")) {
      try {
        $relatedCaseStudies.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: false,
          adaptiveHeight: false,
          mobileFirst: true,
          centerMode: false,
          variableWidth: false,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="#3978CF" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: "unslick",
            },
          ],
        });
      } catch (error) {
        console.warn("Related case studies slider initialization failed:", error);
      }
    }
  }
  initRelatedCaseStudies();

  // 3. Related Blog Posts slider (only when more than 4 posts)
  var $blogPostsSlider = $(".blog-related-block__posts--slider");
  if ($blogPostsSlider.length && !$blogPostsSlider.hasClass("slick-initialized")) {
    try {
      $blogPostsSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        infinite: true,
        adaptiveHeight: false,
        mobileFirst: true,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: "unslick",
          },
        ],
      });
    } catch (error) {
      console.warn("Blog posts slider initialization failed:", error);
    }
  }

  // 4. Related Blog Posts - Mobile-only slider when <= 4 posts
  function initBlogPostsMobile() {
    var $blogPostsMobile = $(".blog-related-block__posts--mobile-slider");
    if ($blogPostsMobile.length && !$blogPostsMobile.hasClass("slick-initialized")) {
      try {
        $blogPostsMobile.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: false,
          infinite: true,
          adaptiveHeight: false,
          mobileFirst: true,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: "unslick",
            },
          ],
        });
      } catch (error) {
        console.warn("Blog related posts mobile slider initialization failed:", error);
      }
    }
  }
  initBlogPostsMobile();

  // 5. Case Studies Carousel - 4+ posts
  var $caseStudiesCarousel = $(".case-studies-carousel__slider");
  if ($caseStudiesCarousel.length) {
    $caseStudiesCarousel.each(function () {
      var $slider = $(this);
      var slideCount = $slider.children().length;

      if (slideCount <= 3 || $slider.hasClass("slick-initialized")) {
        return;
      }

      var $arrows = $slider
        .closest(".case-studies-carousel")
        .find(".case-studies-carousel__arrows");

      try {
        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "15%",
          arrows: true,
          dots: false,
          autoplay: false,
          infinite: true,
          adaptiveHeight: false,
          appendArrows: $arrows.length ? $arrows : undefined,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                centerPadding: "10%",
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                centerPadding: "10%",
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerPadding: "20%",
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                centerPadding: "15%",
              },
            },
          ],
        });
      } catch (error) {
        console.warn("Case studies slider initialization failed:", error);
      }
    });
  }

  // 6. Case Studies Carousel - 1-3 posts
  // Desktop: normal grid, Mobile: slider
  function initCaseStudiesCases() {
    var $caseStudiesCases = $(".case-studies-carousel__cases");
    if ($caseStudiesCases.length) {
      $caseStudiesCases.each(function () {
        var $slider = $(this);
        var slideCount = $slider.children().length;

        if (!slideCount || slideCount > 3 || $slider.hasClass("slick-initialized")) {
          return;
        }

        var $arrows = $slider
          .closest(".case-studies-carousel")
          .find(".case-studies-carousel__arrows");

        try {
          $slider.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20%",
            arrows: true,
            dots: false,
            autoplay: false,
            infinite: slideCount > 1,
            adaptiveHeight: false,
            appendArrows: $arrows.length ? $arrows : undefined,
            prevArrow:
              '<button class="slick-prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow:
              '<button class="slick-next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
              {
                breakpoint: 768,
                settings: "unslick",
              },
            ],
          });
        } catch (error) {
          console.warn("Case studies mobile grid/slider initialization failed:", error);
        }
      });
    }
  }
  initCaseStudiesCases();

  // 7. Team Slider Block
  var $teamSlider = $(".team-slider-block__slider");
  if ($teamSlider.length && !$teamSlider.hasClass("slick-initialized") && $teamSlider.children().length > 0) {
    var $teamArrows = $teamSlider
      .closest(".team-slider-block__slider-wrapper")
      .find(".team-slider-block__arrows");

    try {
      $teamSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1500,
        infinite: true,
        adaptiveHeight: false,
        appendArrows: $teamArrows.length ? $teamArrows : undefined,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous team member"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next team member"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    } catch (error) {
      console.warn("Team slider initialization failed:", error);
    }
  }

  // 8. Logos Block Slider (only when more than 3 logos)
  var $logosBlockSliders = $(".logos-block__slider");

  if ($logosBlockSliders.length) {
    $logosBlockSliders.each(function () {
      var $logosSlider = $(this);

      if (
        !$logosSlider.length ||
        $logosSlider.hasClass("slick-initialized") ||
        $logosSlider.children().length === 0
      ) {
        return;
      }

      try {
        $logosSlider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          infinite: true,
          adaptiveHeight: false,

          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn(
          "Logos block slider initialization failed:",
          error
        );
      }
    });
  }

  // 9. Testimonials Slider
  var $testimonialSlider = $(".testimonials-block__testimonials");
  if ($testimonialSlider.length && !$testimonialSlider.hasClass("slick-initialized") && $testimonialSlider.children().length > 0) {
    var $testimonialArrows = $testimonialSlider
      .closest(".testimonials-block__slider-wrapper")
      .find(".testimonials-block__arrows");

    try {
      $testimonialSlider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 10000,
        infinite: true,
        focusOnSelect: true,
        speed: 600,
        appendArrows: $testimonialArrows.length ? $testimonialArrows : undefined,
        prevArrow:
          '<button class="slick-prev testimonials-prev" aria-label="Previous testimonial"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_5238_17)"><rect width="24" height="24" rx="1" transform="matrix(-1 0 0 1 24 0)" fill="#99E5B2"/><path d="M13.5 15L10.5 12L13.5 9" stroke="#071B2B" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5238_17"><path d="M24 5C24 2.23858 21.7614 0 19 0H5C2.23857 0 0 2.23858 0 5V19C0 21.7614 2.23858 24 5 24H19C21.7614 24 24 21.7614 24 19V5Z" fill="white"/></clipPath></defs></svg></button>',
        nextArrow:
          '<button class="slick-next testimonials-next" aria-label="Next testimonial"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_5238_131)"><rect width="24" height="24" rx="1" fill="#99E5B2"/><path d="M10.5 15L13.5 12L10.5 9" stroke="#071B2B" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5238_131"><path d="M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z" fill="white"/></clipPath></defs></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerPadding: "0",
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: "0",
            },
          },
        ],
      });
    } catch (error) {
      console.warn("Testimonials slider initialization failed:", error);
    }
  }

  // 10. Inner Hero Logos Slider (if more than 3 logos)
  var $innerHeroLogos = $(".inner-hero-block__logos");
  if ($innerHeroLogos.length) {
    $innerHeroLogos.each(function () {
      var $slider = $(this);
      var slideCount = $slider.children().length;

      if (slideCount <= 3 || $slider.hasClass("slick-initialized") || !$slider.length) {
        return;
      }

      try {
        $slider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          adaptiveHeight: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn("Inner hero logos slider initialization failed:", error);
      }
    });
  }

  // 11. Logo Text Block Slider
  var $logoSliders = $(
    ".logo-text-block__logos, .logo-text-block__logos--slider"
  );

  if ($logoSliders.length) {
    $logoSliders.each(function () {
      var $logoSlider = $(this);

      if (
        !$logoSlider.length ||
        $logoSlider.hasClass("slick-initialized") ||
        $logoSlider.children().length === 0
      ) {
        return;
      }

      try {
        $logoSlider.css("visibility", "visible");

        $logoSlider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          infinite: true,
          adaptiveHeight: false,
          pauseOnHover: false,
          lazyLoad: "ondemand",

          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn(
          "Logo text block slider initialization failed:",
          error
        );
      }
    });
  }

  // 12. USP Banner Slider
  function initUspBannerSlider() {
    var $uspSliders = $(".usp-banner__slider");
    if ($uspSliders.length) {
      $uspSliders.each(function () {
        var $slider = $(this);
        var slideCount = $slider.children().length;

        if (!slideCount || $slider.hasClass("slick-initialized")) {
          return;
        }

        // More than 3 USPs: Slide on both desktop and mobile
        if (slideCount > 3) {
          try {
            $slider.slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 2500,
              speed: 500,
              infinite: true,
              adaptiveHeight: false,
              pauseOnHover: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          } catch (error) {
            console.warn("USP banner slider initialization failed:", error);
          }
        } else if (slideCount > 1) {
          // 3 or fewer USPs: Slide on mobile only, unslick on desktop
          try {
            $slider.slick({
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 2500,
              speed: 500,
              infinite: true,
              adaptiveHeight: false,
              pauseOnHover: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 1024,
                  settings: "unslick",
                },
              ],
            });
          } catch (error) {
            console.warn("USP banner mobile slider initialization failed:", error);
          }
        }
      });
    }
  }
  initUspBannerSlider();

  // Window resize handler to re-initialize unslicked sliders when resizing back down to mobile
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(window).width() < 1024) {
        initUspBannerSlider();
      }
      if ($(window).width() < 768) {
        initRelatedCaseStudies();
        initBlogPostsMobile();
        initCaseStudiesCases();
      }
    }, 200);
  });
}); // End of document.ready
